
const BASE_URL = "/api/partizi";

export const partidaApi = {
  // Metoda pentru adăugare
  add: async (data, user) => {
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "user-role": user.rol,
        "user-ocol": user.ocol,
      },
      body: JSON.stringify(data),
    });
    return res.json();
  },
  
 // Metoda pentru actualizare
  update: async (id, data) => {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || "Eroare la actualizarea partizii");
    }
    return res.json();
  },

  // Metoda pentru ștergere
  delete: async (id) => {
    const res = await fetch(`${BASE_URL}/${id}`, { method: "DELETE" });
    return res.json();
  },
};